import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { GtmService } from "../service/gtm/gtm.service";

@Component({
  selector: "app-privacy",
  templateUrl: "./privacy.component.html",
  styleUrls: ["./privacy.component.scss"],
})
export class PrivacyComponent implements OnInit {
  privacy: string;

  constructor(private route: ActivatedRoute, private gtmService: GtmService) {
    this.privacy = privacyText;

    this.gtmService.pageViewWithPage({
      path: this.route.snapshot["_routerState"].url,
      title: "개인정보 처리방침",
      breadcrumb: "Home > 개인정보 처리방침",
    });
  }

  ngOnInit() { }
}

export const privacyText = `
<p>사단법인 루트임팩트에서 운영하는 헤이그라운드(이하 "회사"라 함)는 신용정보의 이용 및 보호에 관한 법률, 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 개인정보보호법 등 준수하여야 할 관련 법규상의 개인정보보호규정을 준수하며, 개인정보보호법에 의거한 개인정보처리방침을 정하여 이용자 권익보호에 최선을 다하고 있습니다.</p>
<br>
<p>개인정보처리방침의 '정보주체' 는 처리되는 정보에 의하여 알아볼 수 있는 사람으로서 그 정보의 주체가 되는 사람을 말합니다. '고객'은 '정보주체' 중 회사가 제공하는 서비스를 이용하는 자(이용하려는 자 포함)를 의미합니다.</p>
<br>
<h5>회사의 개인정보처리방침은 다음과 같은 내용으로 구성되어 있습니다.</h5>
<p>1. 개인정보의 처리 목적</p>
<p>2. 처리하는 개인정보의 항목 및 수집 방법</p>
<p>3. 개인정보의 처리 및 보유기간</p>
<p>4. 개인정보처리의 위탁에 관한 사항</p>
<p>5. 제휴서비스에 필요한 개인정보를 제3자에게 제공하는 사항</p>
<p>6. 개인정보의 파기에 관한 사항</p>
<p>7. 개인정보의 국외 이전</p>
<p>8. 정보주체의 권리·의무 및 그 행사방법에 관한 사항</p>
<p>9. 인터넷 접속정보파일 등 개인정보를 자동으로 수집하는 장치의 설치·운영 및 그 거부에 관한 사항</p>
<p>10. 개인정보의 안전성 확보 조치에 관한 사항</p>
<p>11. 개인정보 보호책임자에 관한 사항</p>
<p>12. 개인정보의 열람청구를 접수·처리하는 부서</p>
<p>13. 정보주체의 권익침해에 대한 구제 방법</p>
<p>14. 개인정보 처리방침의 변경에 관한 사항</p>
<br>
<br>
<h5>1. 개인정보의 처리 목적</h5>
<p>1) 회원제 서비스 이용에 따른 본인여부 식별(확인), 회원가입 등</p>
<p>2) 가입기간 동안의 서비스 제공을 위해 다양한 창구로 수집된 고객의 개인정보 통합관리</p>
<p>3) 이메일 청구서 발송, 이메일 문의, 고지사항 전달, 본인 의사 확인, 불만 처리 등 원활한 의사소통 경로의 확보 및 분쟁조정을 위한 기록보존 등</p>
<p>4) 통계학적 분석(이용자의 서비스 이용에 대한 통계분석, 웹로그분석 등)</p>
<p>5) 서비스, 이벤트정보 등 마케팅정보의 안내</p>
<br>
<h5>2. 처리하는 개인정보의 항목 및 수집 방법</h5>
<p>1) 처리하는 개인정보의 항목</p>
<p>&nbsp; - 회원가입: 성명, ID, 비밀번호, 소속, 직업/담당업무, 생년월일, 이메일주소, 핸드폰번호</p>
<p>&nbsp; - 서비스 제공: 성명, 소속, 직업/담당업무, 생년월일, 이메일주소, 핸드폰번호</p>
<p>&nbsp; - 이메일 청구서 발송: 성명, 이메일주소</p>
<p>&nbsp; - 이메일 문의: 성명, 이메일주소</p>
<p>&nbsp; - 서비스 이용과정이나 사업처리 과정에서 자동으로 수집될 수 있는 항목 : 이용자의 브라우저 종류 및 OS, 검색어, 서비스 이용 기록, IP Address, MAC Address, CPU ID, HDD Serial number, 방문 일시, 서비스 이용기록, 결제기록, 쿠키</p>
<p>2) 개인정보의 수집방법</p>
<p>&nbsp; 가.회사는 [개인정보의 수집ㆍ이용에 대한 동의]에 대해 「동의」버튼을 클릭할 수 있는 절차를 마련하여, 「동의」버튼을 클릭하면 개인정보 수집에 대해 동의한 것으로 봅니다.</p>
<p>&nbsp; 나.회사는 다음과 같은 방법으로 개인정보를 수집합니다.</p>
<p>&nbsp; &nbsp; - 홈페이지, 서면양식, 팩스, 전화, 상담게시판, 이메일, 이벤트/서비스 신청, 서베이 응답, 배송요청</p>
<p>&nbsp; &nbsp; - 협력회사로부터의 제공</p>
<p>&nbsp; &nbsp; - 생성정보 수집 툴을 통한 수집</p>
<br>
<h5>3. 개인정보의 처리 및 보유기간</h5>
<p>회사는 「개인정보의 처리 목적」이 달성될 때까지 개인정보를 보유합니다. 다만, 전자상거래 등에서의 소비자 보호에 관한 법률 등 관계 법령에 따라, 또는 정보주체로부터 사전에 동의를 받은 경우 일정기간 개인정보를 보관합니다.</p>
<p>1) 회사는 상법 등 관련법규에 의하여 보존할 필요성이 있는 다음의 경우에는 개인정보를 일정기간 동안 보유합니다. 관계 법령 위반에 따른 수사ㆍ조사 등이 진행중인 경우에는 해당 수사ㆍ조사 종료시까지, 홈페이지 이용에 따른 채권ㆍ채무관계 잔존시에는 해당 채권ㆍ채무관계 정산시까지 개인정보를 보존합니다.</p>
<p>2) 회사는 다음의 정보에 대해서는 아래 명시한 기간 동안 보존합니다.</p>
<p>&nbsp; 가. 계약 또는 청약철회 등에 관한 기록</p>
<p>&nbsp; &nbsp; - 보존이유 : 전자상거래 등에서의 소비자 보호에 관한 법률</p>
<p>&nbsp; &nbsp; - 보존기간 : 5년</p>
<p>&nbsp; 나. 대금결제 및 재화 등의 공급에 관한 기록</p>
<p>&nbsp; &nbsp; - 보존이유 : 전자상거래 등에서의 소비자 보호에 관한 법률</p>
<p>&nbsp; &nbsp; - 보존기간 : 5년</p>
<p>&nbsp; 다. 소비자의 불만 또는 분쟁처리에 관한 기록</p>
<p>&nbsp; &nbsp; - 보존이유 : 전자상거래 등에서의 소비자 보호에 관한 법률</p>
<p>&nbsp; &nbsp; - 보존기간 : 3년</p>
<p>&nbsp; 라. 기타 고객의 동의를 받은 경우 : 동의를 받은 기간까지</p>
<p>3) 회사는 휴면회원(정보통신서비스를 1년의 기간 동안 이용하지 아니하는 이용자)의 개인정보를 즉시 파기하거나 다른 이용자와의 개인정보와 분리하여 별도 저장ㆍ관리합니다.</p>
<br>
<h5>4. 개인정보처리의 위탁에 관한 사항</h5>
<p>회사는 더 나은 서비스를 제공하기 위하여 정보주체의 개인정보 처리를 외부전문기관에 위탁할 수 있습니다.</p>
<p>1) 회사는 개인정보 처리를 위탁하는 경우 위탁하는 업무의 내용과 수탁자를 정보주체가 언제든지 쉽게 확인할 수 있도록 회사의 인터넷 홈페이지에 지속적으로 게재하여 공개합니다. 특히, 회사가 재화 또는 서비스를 홍보하거나 판매를 권유하는 업무를 위탁하는 경우에는 서면, 전자우편, 팩스, 전화, 문자전송 또는 이에 상당하는 방법(이하 "서면등의 방법"이라 합니다)으로 위탁하는 업무의 내용과 수탁자를 정보주체에게 알려드립니다. 위탁하는 업무의 내용이나 수탁자가 변경된 경우에도 동일합니다. 만약, 회사가 과실 없이 서면등의 방법으로 정보주체에게 알릴 수 없는 경우에는 해당 사항을 인터넷 홈페이지에 30일 이상 게재합니다.</p>
<p>2) 회사는 수탁자에게 다음의 내용이 포함된 문서에 의하여 개인정보의 처리 업무를 위탁하고 있으며, 당해 문서를 서면 또는 전자적으로 보관하여 정보주체의 권익을 보호합니다.</p>
<p>&nbsp; - 위탁업무의 목적 및 범위</p>
<p>&nbsp; - 위탁업무 수행 목적 외 개인정보의 처리 금지에 관한 사항</p>
<p>&nbsp; - 재위탁 제한에 관한 사항</p>
<p>&nbsp; - 개인정보의 기술적·관리적 보호조치에 관한 사항</p>
<p>&nbsp; - 개인정보에 대한 접근 권한 등 안전성 확보 조치에 관한 사항</p>
<p>&nbsp; - 위탁업무와 관련하여 보유하고 있는 개인정보의 관리 현황 점검 등 감독에 관한 사항</p>
<p>&nbsp; - 수탁자가 준수하여야 할 의무를 위반한 경우의 손해배상 등에 관한 사항</p>
<p>3) 회사는 다음과 같이 개인정보를 수탁자에게 제공하고 있습니다.</p>
<p>&nbsp; 가. 채널코퍼레이션</p>
<p>&nbsp; - 수탁업체: 주식회사 채널코퍼레이션</p>
<p>&nbsp; - 위탁내용: 고객상담솔루션</p>
<p>&nbsp; - 제공기간: 위탁 계약 종료시까지</p>
<br>
<h5>5. 개인정보의 제3자 제공에 관한 사항</h5>
<p>1) 회사는 정보주체의 개인정보를 제1조(개인정보의 처리 목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.</p>
<p>2) 회사는 다음과 같이 개인정보를 제3자에게 제공하고 있습니다.</p>
<p>&nbsp; 가. 모두의주차장</p>
<p>&nbsp; &nbsp; - 개인정보를 제공받는 자 : 주식회사 모두컴퍼니 </p>
<p>&nbsp; &nbsp; - 제공받는 자의 개인정보 이용목적 : 서울숲점 주차결제 자동화 시스템 운영 </p>
<p>&nbsp; &nbsp; - 제공하는 개인정보 항목 : 성명, 이메일주소,  입주사명, 소속 지점명</p>
<p>&nbsp; &nbsp; - 제공받는 자의 보유․이용기간 : 멤버십 계약 철회 시 까지</p>
<br>
<h5>6. 개인정보의 파기에 관한 사항</h5>
<p>회사는 원칙적으로 고객이 탈회하거나 제명될 시 또는 고객의 소속 입주사가 멤버십 계약을 종료할 시 고객의 개인정보를 지체 없이 파기합니다. 다만, 전자상거래 등에서의 소비자 보호에 관한 법률 등 관계 법령에 따라 또는 정보주체로부터 사전에 동의를 받은 경우 일정기간 개인정보를 보관합니다. 개인정보의 파기는 다음과 같은 절차 및 방법에 따릅니다.</p>
<p>1) 파기 절차</p>
<p>&nbsp; - 고객의 탈회나 제명 또는 소속 입주사의 멤버십 계약 종료 시 1개월 이내로 고객의 개인정보를 파기합니다. </p>
<p>&nbsp; - 다만, 관계 법령에 따라 일정기간 보관이 필요한 정보는 1개월 이내로 별도의 DB로 옮겨 보관하고 보관 사유가 말소되면 파기합니다.</p>
<p>2) 파기 방법</p>
<p>&nbsp; - 전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법으로 삭제되며, 종이 등 기타 매체에 저장된 개인정보는 파쇄, 소각, 용해 등의 방법으로 파기합니다.</p>
<br>
<h5>7. 개인정보의 국외 이전</h5>
<p>회사는 서비스 제공 및 「개인정보의 처리 목적」 달성을 위하여 고객의 정보를 아래와 같이 국외로 전송 또는 관리할 수 있습니다.</p>
<p>&nbsp; - 개인정보를 이전받는 업체 : Google LLC.</p>
<p>&nbsp; - 정보관리책임자의 성명 및 연락처 : Google LLC. privacy team / googlekrsupport@google.com / Privacy Matters c/o Google LLC, 1600 Amphitheatre Parkway, Mountain View, California, 94043 USA</p>
<p>&nbsp; - 이전 목적 : 고객 정보 통합 관리 및 분석</p>
<p>&nbsp; - 이전되는 개인정보 항목 : 성명, 소속, 이메일주소, 핸드폰번호, 직업/담당업무, 생년월일</p>
<p>&nbsp; - 이전되는 국가 : 미국</p>
<p>&nbsp; - 이전 일시 및 방법 : 회사의 고객정보 통합관리 목적에 따른 데이터 입력 및 서비스 신청, 설문조사 참여 시(구글 설문) 네트워크를 통한 전송 </p>
<p>&nbsp; - 이전받는 자의 개인정보 보유 · 이용 기간 : 회사의 개인정보 파기 또는 서비스 변경 시까지(현재 회사가 이용 중인 클라우드 서비스 이용 변경 시까지)</p>
<br>

<h5>8. 정보주체의 권리·의무 및 그 행사방법에 관한 사항</h5>
<p>1) 개인정보의 열람</p>
<p>&nbsp; 가. 정보주체는 회사가 처리하는 자신의 개인정보에 대하여 행정안전부령으로 정하는 바에 따라 개인정보 열람요구서를 회사에 제출하는 등의 방법으로 열람을 요구할 수 있습니다.</p>
<p>&nbsp; 나. 회사는 열람을 요구 받으면 그로부터 10일 이내에 정보주체가 해당 개인정보를 열람할 수 있게 합니다. 만약 해당 기간 내에 열람할 수 없는 사유가 있을 때에는 요구를 받은 날부터 10일 이내에 정보주체에게 그 사유 및 이의제기방법을 알리고 열람을 연기할 수 있으며, 그 사유가 소멸한 경우에는 정당한 사유가 없는 한 사유가 소멸한 날로부터 10일 이내에 열람하도록 할 수 있습니다.</p>
<p>&nbsp; 다. 회사는 다음의 어느 하나에 해당하는 경우 정보주체에게 그 사유를 알리고 열람을 제한하거나 거절할 수 있습니다. 이 경우 열람이 제한되는 사항을 제외한 부분은 열람할 수 있으며, 열람 요구를 받은 날부터 10일 이내에 그 사유 및 이의제기방법을 알려드립니다.</p>
<p>&nbsp; ① 법률에 따라 열람이 금지되거나 제한되는 경우</p>
<p>&nbsp; ② 다른 사람의 생명 · 신체를 해할 우려가 있거나 다른 사람의 재산과 그 밖의 이익을 부당하게 침해할 우려가 있는 경우</p>
<p>2) 개인정보의 정정 · 삭제</p>
<p>&nbsp; 가. 「개인정보의 열람」에 따라 자신의 개인정보를 열람한 정보주체는 그 개인정보의 정정 또는 삭제를 행정안전부령으로 정하는 바에 따라 개인정보 정정ㆍ삭제 요구서를 회사에 제출하는 등의 방법으로 요구할 수 있습니다. 다만, 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.</p>
<p>&nbsp; 나. 회사는 정보주체의 요구를 받은 경우 개인정보의 정정 또는 삭제에 관하여 다른 법령에 특별한 절차가 규정되어 있는 경우를 제외하고는 정당한 사유가 없는 한 요구를 받은 날로부터 10일 이내에 그 개인정보를 조사하여 정보주체의 요구에 따라 정정ㆍ삭제 등 필요한 조치를 한 후 그 결과를 알려드립니다. 제휴사 등 다른 개인정보처리자로부터 적법하게 제공받은 개인정보의 정정 또는 삭제 요구를 받으면 제공한 기관에도 정정ㆍ삭제 요구를 알려드리고 그 처리 결과에 따라 필요한 조치를 취합니다. 회사는 조사를 할 때 필요하면 개인에게 정정 · 삭제 요구사항의 확인에 필요한 증거를 요청할 수 있으며, 개인정보를 삭제할 때에는 복구 또는 재생되지 아니하도록 조치하고 있습니다.</p>
<p>&nbsp; 다. 회사는 다음의 어느 하나에 해당하는 경우 정정ㆍ삭제를 거부할 수 있으며, 정당한 사유가 없는 한 정보주체의 요구를 받은 날로부터 10일 이내에 정정ㆍ삭제를 할 수 없는 사유와 이의제기방법을 알려드립니다.</p>
<p>&nbsp; &nbsp; ① 법률에 따라 열람이 금지되거나 제한되는 경우</p>
<p>&nbsp; &nbsp; ② 다른 사람의 생명 · 신체를 해할 우려가 있거나 다른 사람의 재산과 그 밖의 이익을 부당하게 침해할 우려가 있는 경우</p>
<p>3) 개인정보의 처리정지 </p>
<p>&nbsp; 가. 정보주체는 회사에 대하여 행정안전부령으로 정하는 바에 따라 개인정보 처리정지 요구서를 회사에 제출하는 등의 방법으로 자신의 개인정보 처리의 정지를 요구할 수 있습니다.</p>
<p>&nbsp; 나. 회사는 정당한 사유가 없는 한 요구를 받은 날로부터 10일 이내에 정보주체의 요구에 따라 개인정보 처리의 전부를 정지하거나 일부를 정지하고, 처리가 정지된 개인정보에 대하여 처리정지의 요구를 받은 날로부터 10일 이내에 필요한 조치를 하여야 합니다. 다만, 다음의 어느 하나에 해당하는 경우에는 정보주체의 처리정지 요구를 거절할 수 있으며, 이 경우 정보주체에게 요구를 받은 날로부터 10일 이내에 그 사유를 알려주어야 합니다.</p>
<p>&nbsp; &nbsp; ① 법률에 특별한 규정이 있거나 법령상 의무를 준수하기 위하여 불가피한 경우</p>
<p>&nbsp; &nbsp; ② 다른 사람의 생명 · 신체를 해할 우려가 있거나 다른 사람의 재산과 그 밖의 이익을 부당하게 침해할 우려가 있는 경우</p>
<p>&nbsp; &nbsp; ③ 개인정보를 처리하지 아니하면 정보주체와 약정한 서비스를 제공하지 못하는 등 계약의 이행 이 곤란한 경우로써 정보주체가 그 계약의 해지 의사를 명확하게 밝히지 아니한 경우</p>
<p>4) 권리행사의 방법 및 절차</p>
<p>회사는 개인정보의 수집시에 요구되지 않았던 증빙서류 등을 요구하거나 추가적인 절차를 요구하지 않습니다.</p>
<p>&nbsp; 가. 정보주체는 개인정보의 열람, 정정ㆍ삭제, 처리정지 요구를 대리인(정보주체의 법정대리인, 정보주체로부터 위임을 받은 자)에게 하게 할 수 있습니다. 이 경우, 대리인은 회사에 정보주체의 위임장을 제출하여야 합니다.</p>
<p>&nbsp; 나. 만 14세 미만 아동의 법정대리인은 회사에게 그 아동의 개인정보 열람, 정정ㆍ삭제, 처리정지 요구를 할 수 있습니다.</p>
<br>
<h5>9. 인터넷 접속정보파일 등 개인정보를 자동으로 수집하는 장치의 설치·운영 및 그 거부에 관한 사항</h5>
<p>&nbsp; 1)쿠키의 사용 목적 회사는 고객에게 특화된 맞춤서비스를 제공하기 위해서 고객의 정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용합니다. 쿠키는 웹사이트를 운영하는데 이용되는 서버(HTTP)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터내의 하드디스크에 저장되기도 합니다.</p>
<p>&nbsp; 2) 쿠키의 설치/운영 및 거부 고객은 쿠키설치에 대한 선택권을 가지고 있습니다. 따라서, 고객은 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다.</p>
<p>&nbsp; &nbsp; - 설정방법 예(인터넷 익스플로어의 경우) : 웹 브라우저 상단의 도구 > 인터넷 옵션 > 개인정보</p>
<p>&nbsp; &nbsp; 다만, 쿠키의 저장을 거부할 경우에는 로그인이 필요한 서비스는 이용할 수 없습니다.</p>
<br>
<h5>10. 개인정보의 안전성 확보 조치에 관한 사항</h5>
<p>회사는 정보주체의 개인정보를 취급함에 있어 개인정보가 분실, 도난, 유출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 안전성 확보 조치를 강구하고 있습니다.</p>
<p>&nbsp; 가. 개인정보에 대한 접근 통제 및 접근 권한의 제한 조치</p>
<p>&nbsp; &nbsp; ① 회사는 개인정보처리시스템에 대한 접근권한을 업무 수행에 필요한 최소한의 범위로 하여 업무 담당자 별로 한 개의 사용자 계정을 차등 부여하고 있으며, 개인정보취급자가 변경되었을 경우 지체 없이 개인정보처리시스템의 접근권한을 변경 또는 말소하고 그 기록을 최소 3년간 보관하고 있습니다.</p>
<p>&nbsp; &nbsp; ② 회사는 개인정보취급자의 비밀번호 작성규칙을 수립하여 적용하고 있습니다.</p>
<p>&nbsp; &nbsp; ③ 회사는 개인정보처리시스템에 대한 불법적인 접근 및 침해사고 방지를 위해 접근 제한 시스템과 유출 시도 탐지 시스템을 운영하고 있습니다. 개인정보취급자가 외부에서 회사의 개인정보처리시스템에 접속하려는 경우에는 가상사설망(VPN) 또는 전용선 등 안전한 접속수단에 의한 접속만 가능합니다. 또한, 개인정보가 권한이 없는 자에게 공개되거나 외부에 유출되지 않도록 개인정보처리시스템 및 업무용 컴퓨터에 조치를 취하고 있습니다.</p>
<p>&nbsp; 나. 접속기록의 보관 및 위조ㆍ변조 방지를 위한 조치</p>
<p>&nbsp; &nbsp; 회사는 개인정보취급자가 개인정보처리시스템에 접속한 기록을 최소 6개월 이상 보관 · 관리하며, 개인정보취급자의 접속기록이 위 · 변조 및 도난, 분실되지 않도록 해당 접속기록을 안전하게 보관하고 있습니다.</p>
<p>&nbsp; 다. 개인정보에 대한 보안프로그램의 설치 및 갱신 회사는 개인정보처리시스템 또는 업무용 컴퓨터에 악성 프로그램 등을 방지 · 치료할 수 있는 백신 소프트웨어 등의 보안 프로그램을 설치 · 운영하고 있으며, 보안 프로그램의 자동 업데이트 기능을 사용하고 일 1회 PC 검사를 실시하고 있습니다. 또한 악성 프로그램관련 경보가 발령된 경우 또는 사용 중인 응용 프로그램이나 운영체제 소프트웨어의 제작업체에서 보안 업데이트 공지가 있는 경우, 즉시 이에 따른 업데이트를 실시하고 있습니다.</p>
<p>&nbsp; 라. 개인정보의 안전한 보관을 위한 물리적 조치</p>
<p>&nbsp; &nbsp; 회사는 전산실, 자료보관실 등 개인정보를 보관하고 있는 물리적 보관 장소에 대한 출입통제 절차를 수립·운영하고 있으며, 개인정보가 포함된 서류, 보조저장매체 등을 잠금장치가 있는 안전한 장소에 보관하고 있습니다.</p>
<br>
<h5>11. 개인정보 보호책임자에 관한 사항</h5>
<p>회사는 고객의 개인정보를 보호하고 개인정보와 관련한 고객의 불만사항을 처리하기 위하여 개인정보보호책임자를 두고 있습니다.</p>
<p>개인정보와 관련한 문의사항이 있으시면 아래의 개인정보보호책임자 또는 개인정보관리담당자에게 연락하여 주시기 바랍니다. </p>
<br>
<p>&nbsp; 가. 헤이그라운드 개인정보보호책임자 </p>
<p>&nbsp; &nbsp; - 성명 : 허재형</p>
<p>&nbsp; &nbsp; - 소속 : 루트임팩트</p>
<p>&nbsp; &nbsp; - 직책 : 대표</p>
<p>&nbsp; 나. 헤이그라운드 개인정보관리담당자</p>
<p>&nbsp; &nbsp; - 부서명 : 헤이그라운드 팀</p>
<p>&nbsp; &nbsp; - 담당자 : 이형우</p>
<p>&nbsp; &nbsp; - 전화번호 : 02-6495-0182</p>
<p>&nbsp; &nbsp; - E-mail : hw.yi@rootimpact.org</p>
<br>
<h5>12. 개인정보의 열람청구 접수ㆍ처리 부서</h5>
<p>1) 회사는 개인정보의 열람청구와 관련하여 고객과의 원활한 의사소통을 위해 고객상담센터를 운영하고 있으며 연락처는 다음과 같습니다.</p>
<p>&nbsp; 가. 헤이그라운드 </p>
<p>&nbsp; &nbsp; - 전화번호 : 02-6495-0182</p>
<p>&nbsp; &nbsp; - 주 소 : 서울특별시 성동구 뚝섬로1나길 5 G205호</p>
<br>
<h5>13. 문의정보</h5>
<p>정보주체의 권익침해에 대한 구제방법개인정보에 관한 권익을 침해당한 경우 개인정보침해신고센터, 대검찰청 사이버수사과, 경찰청 사이버수사국 등으로 문의하실 수 있습니다.</p>
<p>&nbsp; 가. 개인정보침해신고센터 </p>
<p>&nbsp; &nbsp; - 전화번호 : 118</p>
<p>&nbsp; &nbsp; - URL : http://privacy.kisa.or.kr</p>
<p>&nbsp; 나. 대검찰청 사이버수사과 </p>
<p>&nbsp; &nbsp; - 전화번호 : 1301</p>
<p>&nbsp; &nbsp; - URL : https://www.spo.go.kr</p>
<p>&nbsp; 다. 경찰청 사이버수사국</p>
<p>&nbsp; &nbsp; - 전화번호 : 182</p>
<p>&nbsp; &nbsp; - URL : https://ecrm.cyber.go.kr/minwon/main</p>
<br>
<h5>14. 처리방침 변경에 관한 사항</h5>
<p>본 『개인정보 처리방침』은 2017년 5월 12일에 최초 게시되며, 내용 추가, 삭제 및 수정이 있을 시에는 홈페이지첫화면의 공지사항 또는 별도의 창을 통해 고지합니다.</p>
<br>
<p>공고일자 : 2021.05.10 시행일자 : 2021.05.10</p>
`;



// WEBPACK FOOTER //
// ./src/app/privacy/privacy.component.ts